module.exports = function(h, row) {
    if (row.value) {
        return 'RM' + row.value;
    } else {
        return '';
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/couponredeem/value.jsx